import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { FieldArray } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";

import { Col, Divider, Flex, Row } from "antd";
import { Select, Switch, TimePicker } from "components/form";

import { ACTION } from "features/payment/schemas/PaymentShemas";
import styles from "../styles/Attendance.module.css";
import { useSelector } from "react-redux";

function ShiftsPeriodsForm({
  values = {},
  weekDayWorkingOptions = [],
  weekWorkingOptions = [],
}) {
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  let disabledContent = values?.type === ACTION.VIEW ? true : false;
  return (
    <>
      <Row gutter={[8, 8]} align="middle">
        <Col span={values.advanceSetting ? 3 : 2}>
          <p className="text-table">{t("shift.label.ship_periods_activate")}</p>
        </Col>
        <Col span={values.advanceSetting ? 4 : 5}>
          <p className="text-table">
            {t("shift.label.ship_periods_working_day")}
          </p>
        </Col>
        <Col span={values.advanceSetting ? 4 : 5}>
          <p className="text-table">{t("shift.label.ship_periods_option")}</p>
        </Col>
        <Col span={4}>
          <p className="text-table">
            {t("shift.label.ship_periods_work_time")}
          </p>
        </Col>
        <Col span={4}>
          <p className="text-table">
            {t("shift.label.ship_periods_break_time")}
          </p>
        </Col>
        <Col span={4}>
          <p className="text-table">{t("shift.label.ship_periods_ot")}</p>
        </Col>
        {values.advanceSetting ? <Col span={1}></Col> : <></>}
      </Row>
      <Divider style={{ margin: "8px 0 !important" }} />
      {values.advanceSetting ? (
        <FieldArray
          name="advanceShifts"
          render={(arrayHelpers) => {
            return (
              <Row gutter={[8, 8]} align="middle">
                {values.advanceShifts.map((_, index) => {
                  return (
                    <React.Fragment key={index}>
                      <Col span={3}>
                        <Flex justify="center">
                          <Switch
                            name={`advanceShifts[${index}].activateDeactivate`}
                            disabled={disabledContent}
                          />
                        </Flex>
                      </Col>
                      <Col span={4}>
                        <Select
                          name={`advanceShifts[${index}].workingDayId`}
                          size="large"
                          options={weekDayWorkingOptions}
                          disabled={disabledContent}
                        />
                      </Col>
                      <Col span={4}>
                        <Select
                          name={`advanceShifts[${index}].optionId`}
                          size="large"
                          className={styles.widthTime}
                          options={weekWorkingOptions}
                          disabled={disabledContent}
                        />
                      </Col>
                      <Col span={4}>
                        <Row>
                          <TimePicker
                            name={`advanceShifts[${index}].workTimeStart`}
                            className={styles.timepiker}
                            suffeicon={true}
                            format="HH:mm:ss"
                            size="large"
                            disabled={disabledContent}
                          />
                          <TimePicker
                            name={`advanceShifts[${index}].workTimeEnd`}
                            className={styles.timepiker}
                            suffeicon={true}
                            format="HH:mm:ss"
                            size="large"
                            disabled={disabledContent}
                          />
                        </Row>
                      </Col>
                      <Col span={4}>
                        <Row>
                          <TimePicker
                            name={`advanceShifts[${index}].breakTimeStart`}
                            className={styles.timepiker}
                            suffeicon={true}
                            format="HH:mm:ss"
                            size="large"
                            disabled={disabledContent}
                          />
                          <TimePicker
                            name={`advanceShifts[${index}].breakTimeEnd`}
                            className={styles.timepiker}
                            suffeicon={true}
                            format="HH:mm:ss"
                            size="large"
                            disabled={disabledContent}
                          />
                        </Row>
                      </Col>
                      <Col span={4}>
                        <Row>
                          <TimePicker
                            name={`advanceShifts[${index}].otTimeStart`}
                            className={styles.timepiker}
                            suffeicon={true}
                            format="HH:mm:ss"
                            size="large"
                            disabled={disabledContent}
                          />
                          <TimePicker
                            name={`advanceShifts[${index}].otTimeEnd`}
                            className={styles.timepiker}
                            suffeicon={true}
                            format="HH:mm:ss"
                            size="large"
                            disabled={disabledContent}
                          />
                        </Row>
                      </Col>
                      <Col span={1}>
                        {roles.includes("DELETE_CONFIGURATION|ATTENDANCE_SETTING|SHIFT") && values?.type !== ACTION.VIEW && values.advanceShifts.length > 1 && (
                          <MinusCircleOutlined
                            className={styles.miniMinusBtn}
                            onClick={() => arrayHelpers.remove(index)}
                          />
                        )}
                        {values?.type !== ACTION.VIEW && values.advanceShifts.length === index + 1 && (
                          <PlusCircleOutlined
                            className={styles.miniplusBtn}
                            onClick={() =>
                              arrayHelpers.push({
                                activateDeactivate: null,
                                workingDayId: null,
                                optionId: weekWorkingOptions?.find?.(o => o.code == 'ALLWEEK')?.id,
                                workTimeStart: "08:30:00",
                                workTimeEnd: "17:30:00",
                                breakTimeStart: "12:00:00",
                                breakTimeEnd: "13:00:00",
                                otTimeStart: "00:00:00",
                                otTimeEnd: "00:00:00",
                              })
                            }

                          />
                        )}
                      </Col>
                    </React.Fragment>
                  );
                })}
              </Row>
            );
          }}
        />
      ) : (
        <FieldArray
          name="normalShifts"
          render={(arrayHelpers) => {
            return (
              <Row gutter={[8, 8]} align="middle">
                {values.normalShifts.map((_, index) => {
                  return (
                    <React.Fragment key={index}>
                      <Col span={2}>
                        <Switch
                          name={`normalShifts[${index}].activateDeactivate`}
                        />
                      </Col>
                      <Col span={5}>
                        <Select
                          name={`normalShifts[${index}].workingDayId`}
                          size="middle"
                          options={weekDayWorkingOptions}
                          disabled
                        />
                      </Col>
                      <Col span={5}>
                        <Select
                          name={`normalShifts[${index}].optionId`}
                          size="middle"
                          className={styles.widthTime}
                          options={weekWorkingOptions}
                        />
                      </Col>
                      <Col span={4}>
                        <Row>
                          <TimePicker
                            name={`normalShifts[${index}].workTimeStart`}
                            className={styles.timepiker}
                            suffeicon={true}
                            format="HH:mm:ss"
                            size="large"
                          />
                          <TimePicker
                            name={`normalShifts[${index}].workTimeEnd`}
                            className={styles.timepiker}
                            suffeicon={true}
                            format="HH:mm:ss"
                            size="large"
                          />
                        </Row>
                      </Col>
                      <Col span={4}>
                        <Row>
                          <TimePicker
                            name={`normalShifts[${index}].breakTimeStart`}
                            className={styles.timepiker}
                            suffeicon={true}
                            format="HH:mm:ss"
                            size="large"
                          />
                          <TimePicker
                            name={`normalShifts[${index}].breakTimeEnd`}
                            className={styles.timepiker}
                            suffeicon={true}
                            format="HH:mm:ss"
                            size="large"
                          />
                        </Row>
                      </Col>
                      <Col span={4}>
                        <Row>
                          <TimePicker
                            name={`normalShifts[${index}].otTimeStart`}
                            className={styles.timepiker}
                            suffeicon={true}
                            format="HH:mm:ss"
                            size="large"
                          />
                          <TimePicker
                            name={`normalShifts[${index}].otTimeEnd`}
                            className={styles.timepiker}
                            suffeicon={true}
                            format="HH:mm:ss"
                            size="large"
                          />
                        </Row>
                      </Col>
                    </React.Fragment>
                  );
                })}
              </Row>
            );
          }}
        />
      )}
    </>
  );
}

export default ShiftsPeriodsForm;
